<template>
  <div class="s-layout" :style="colorObject">
    <div class="s-container">
      <Header
        v-if="true"
        :page-title="getModuleConfig('page_title')"
        :page-image="getModuleConfig('page_image')"
        :page-kv-image="getModuleConfig('page_kv_image')"
        :header-section="headerSection"
        :meta="meta"
      />

      <div
        v-if="getModuleConfigForPage('form_title')"
        class="page__title"
      >
        {{ getModuleConfigForPage("form_title") }}
      </div>
      <div v-if="getModuleConfigForPage('form_desc')" class="page__desc">
        {{ getModuleConfigForPage("form_desc") }}
      </div>

      <div class="s-tabs">
        <button
          class="s-tab"
          v-for="tab in tabs"
          :key="tab.order"
          @click="handleClickTab(tab)"
        >
          {{ tab.title }}
      </button>
      </div>
      <router-view />
      <MaacModal
        ref="maacModal"
        :qr-code-text="maacModalData.qrCodeText"
        :is-loading-qr-code="maacModalData.isLoadingQrCode"
        :redirect-url="maacModalData.redirectUrl"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { themeColorFn } from "@/mixins/liff/themeColor";
import Header from "@/components/Page/Liff/Shared/HeaderV3";
import MaacModal from "./MaacModal.vue";
import cresclabMenuApi from "@/apis/liff/v2/cresclab-menu";
import { setTitle, setMeta } from '@/store/modules/liff/helpers';

export default {
  components: {
    Header,
    MaacModal,
  },
  mixins: [themeColorFn({ themeConfigPage: 'liff_page' })],
  data() {
    return {
      maacModalData: {
        qrCodeText: '',
        redirectUrl: '',
        isLoadingQrCode: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
    }),
    pageConfigKey() {
      return this.$route.params.autoPage + "_page";
    },
    pageName() {
      return this.$route.params.autoPage;
    },
    tabs: function () {
      return (this.pageModuleConfig?.page_menus ?? []).sort((a,b)=> a.order - b.order);
    },
    headerSection() {
      let headerSection = this.getModuleConfig('header_section');
      headerSection.enable_menu_items = this.pageModuleConfig.enable_menu_items ?? headerSection.enable_menu_items;
      headerSection.enable_page_title = this.pageModuleConfig.enable_page_title ?? headerSection.enable_page_title;
      headerSection.enable_page_image = this.pageModuleConfig.enable_page_image ?? headerSection.enable_page_image;
      headerSection.enable_page_kv_image = this.pageModuleConfig.enable_page_kv_image ?? headerSection.enable_page_kv_image;
      return headerSection;
    },
    pageModuleConfig() {
      return this.getModuleConfig(this.pageConfigKey);
    },
  },
  async mounted() {
    this.setBrowserTitle();
    this.fetchInstitutionData();
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('liff_page', key);
    },
    getModuleConfigForPage(key) {
      return this.$store.getters["liffModule/getConfig"]('liff_page', this.pageConfigKey + '.' + key);
    },
    setBrowserTitle() {
      if (this.pageModuleConfig.browser_title) {
        setTitle(this.pageModuleConfig.browser_title);
        setMeta('og:site_title', this.pageModuleConfig.browser_title);
      }
    },
    async fetchInstitutionData() {
      try {
        const institutionResponse = await cresclabMenuApi.getTargetInstitution(this.pageName);
        const maacUrl = _.get(institutionResponse, 'data.data.maac_url', null);
        this.maacModalData.qrCodeText = maacUrl;
        if (null !== maacUrl) {
          this.maacModalData.isLoadingQrCode = false;
        }
      } catch (error) {
        console.error('Failed to list institutions:', error);
      }
    },
    handleClickTab(tab) {
      if (tab.hashtag === 'maac') {
        this.showMaacModal(tab)
      } else {
        this.goToTabLink(tab)
      }
    },
    showMaacModal(tab) {
      this.maacModalData.redirectUrl = tab.url || '';
      this.$refs.maacModal.open();
    },
    goToTabLink(tab) {
      if (tab.is_external) {
        window.open(tab.url, '_blank');
      } else {
        window.location.href = tab.url;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page__title {
  padding: 24px;
  background-color: #57A572;
  color: #ffffff;
}

.s-tab {
  color: #222222;
}
</style>

<style lang="scss">
@import "../../../../../assets/css/liff/main.css";
@import "../../../../../assets/css/liff/liff_init_theme_config.css";

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
  --s-danger: #fe0000;
}

.s-container {
  min-height: 100vh;
}

.page {
  padding: 16px 12px;
  background: var(--liff-content_bg_color);

  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 16px;
    text-align: center;
    // color: var(--liff-primary_text_color) !important;
  }

  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color) !important;
    margin-bottom: 16px;
    text-align: center;

    b {
      color: var(--primary-color) !important;
      font-weight: 600;
    }
  }

  &__content{
    a { text-decoration: underline;}
  }

  &__button {
    padding: 12px;
    color: var(--liff-primary_text_color) !important;
  }
}

.s-tabs {
  display: flex;
  background-color: var(--s-white);
  position: sticky;
  top:0;
  z-index: 10;

  .s-tab {
    font-weight: 600;
    font-size: 15px;
    line-height: 21px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    border-bottom: 1px solid #e5e5ea;

    // color: var(--liff-tab_inactive_color) !important;



    // &.router-link-exact-active, &.active {
    //   border-bottom: 2px solid var(--liff-tab-color);
    //   color: var(--liff-tab-color);
    // }
  }

  a.active-tab {
    border-bottom: 2px solid var(--liff-tab-color);
    color: var(--liff-tab-color) !important;
  }
}
</style>
